import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  children: React.ReactNode
}

export default function CardHeader({ className, children }: Props) {
  return (
    <div
      className={twMerge(
        'w-full px-4 py-3 truncate font-medium dark:font-normal text-sm bg-zinc-100 dark:bg-zinc-950/50 border-b',
        className,
      )}
    >
      {children}
    </div>
  )
}
